module.exports = __webpack_public_path__ + "assets/img/sabc_main_logo_old.webp?4c2da9e867786538aeb6d0773b2f79cb";